import common from './common'

export default {
  ...common.button,
  color: `omegaDark`,
  bg: `omegaLight`,
  borderColor: `omegaLight`,
  ':hover': {
    bg: `white`,
    borderColor: `alpha`
  }
}
